<!-- 
  回款计划 组件
    props: ['moduleName', 'contractNo', 'totalMoney', 'contractId'],
    利用Vuex进行的一系列操作
 -->

<template>
  <div class="payment">
    <div class="item">
      <div class="edit" v-if="editPaymentData.length">
        <p class="hint">已有回款计划</p>
        <div class="v-payment"
          v-for="(payment, index) in editPaymentData"
          :key="'edit-' + payment[0].id">
          <div class="content">
            <add-new-form
              ref="addNewForm"
              :paymentData="payment"
              :payMethodArray="payMethodArray"
              :disabled="payment[0].nonEditable"
            ></add-new-form>
          </div>
          <div class="delete" v-if="!payment[0].nonEditable && permission.isDel" @click="deleteData('edit', index)">
            <i class="web-icon-close-tinny"></i>
          </div>
        </div>
      </div>
      <div class="edit">
        <p class="hint">新增回款计划<span class="totalMoney">(可添加回款金额: {{allMoney}})</span></p>
        <div v-if="addPaymentData.length">
          <div class="v-payment"
            v-for="(payment, index) in addPaymentData"
            :key="'add-' + payment[0].soId">
            <div class="content">
              <add-new-form
                ref="addNewForm"
                :paymentData="payment"
                :payMethodArray="payMethodArray"
              ></add-new-form>
            </div>
            <div class="delete" @click="deleteData('add', index)">
              <i class="web-icon-close-tinny"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-button size="small" type="primary" @click="addPayment">添加回款计划</el-button>
  </div>
</template>

<script>
import * as api from 'src/api'
import * as utils from 'src/utils'
import { Message } from 'element-ui'
import { mapGetters, mapActions } from 'vuex'
import addNewForm from 'components/common/add-new-form'

export default {
  props: ['moduleName', 'contractNo', 'totalMoney', 'contractId'],
  created () {
    this.initPayment()
    this.getEditPaymentArray()
  },
  data () {
    return {
      template: [], // 新增的回款计划模板
      belonger: {}, // 默认归属人
      contractInfo: {},
      paymentNo: this.contractNo,
      permission: {},
      payMethodArray: []
    }
  },
  computed: {
    ...mapGetters([
      'editPaymentMoney',
      'addPaymentData',
      'editPaymentData',
      'paymentNoMax'
    ]),
    contractMoney () {
      if (this.moduleName === 'payment') {
        return Number(this.contractInfo.amount || 0)
      } else {
        return Number(this.totalMoney)
      }
    },
    allMoney () {
      let money = 0
      this.editPaymentMoney.map((payment) => {
        money = utils.plus(money, Number(payment.money))
      })
      return Number(utils.subtract(this.contractMoney, money, 6))
    }
  },
  components: {
    addNewForm
  },
  methods: {
    ...mapActions([
      'setAddPaymentData',
      'setEditPaymentData',
      'initPayment',
      'setEditPaymentMoney',
      'setPaymentNoMax'
    ]),
    addPayment () {
      if (!this.permission.isAdd) {
        Message({
          type: 'error',
          message: '您无添加回款计划权限'
        })
        return
      }
      if (this.moduleName === 'contractApi' && (this.totalMoney === '' || this.totalMoney === undefined)) {
        Message({
          type: 'error',
          message: '请输入合同金额'
        })
      } else {
        let newArray = JSON.parse(JSON.stringify(this.template))
        this.addPaymentData.push(this.formatPayment(newArray))
        this.setAddPaymentData(this.addPaymentData)
      }
    },
    formatPayment (newArray) {
      newArray.forEach((payment) => {
        // 为新加的回款计划添加编号
        if (payment.attr === 'paymentNo') {
          if (payment.attrValue) {
            let attrValue = payment.attrValue
            const index = attrValue.lastIndexOf('.')
            let num = Number(attrValue.slice(index + 1)) || 0
            if (this.paymentNoMax) {
              if (num > this.paymentNoMax) {
                this.setPaymentNoMax(num)
              }
            } else {
              this.setPaymentNoMax(num)
            }
          } else {
            payment.attrValue = this.paymentNo + '.' + (this.paymentNoMax + 1)
            this.setPaymentNoMax(this.paymentNoMax + 1)
          }
        } else if (payment.attr === 'status') {
          payment.extraAttrValue = this.belonger
        }

        // 已有回款计划只允许在编辑合同时修改未收款的
        if (payment.id) {
          if (payment.attr === 'status' && payment.attrValue === '1') {
            payment.isBelonger = true
          } else if (payment.attr === 'amount') {
            this.setEditPaymentMoney({id: payment.id, money: payment.attrValue})
          }
          if (!this.permission.isEdit) {
            payment.nonEditable = true
          }
        } else {
          payment.isBelonger = true
        }

        payment.soId = this.paymentNoMax + 1
      })
      return newArray
    },
    deleteData (type, index) {
      if (type === 'add') {
        let addPayment = JSON.parse(JSON.stringify(this.addPaymentData))
        addPayment.splice(index, 1)
        this.setAddPaymentData(addPayment)
      } else {
        let editPayment = JSON.parse(JSON.stringify(this.editPaymentData))
        let paymentArray = editPayment[index]

        this.setEditPaymentMoney({id: paymentArray[0].id || 0, money: 0})
        editPayment.splice(index, 1)
        this.setEditPaymentData(editPayment)
      }
    },
    getEditPaymentArray () {
      const url = '/contractApi/getPaymentsDetail.html'
      const params = {
        contractId: this.contractId || 0
      }
      api.post(url, params, (data) => {
        if (this.moduleName === 'payment') {
          this.contractInfo = data.contractInfo
          this.paymentNo = data.contractInfo.contractNo
        }
        this.permission = data.permission
        this.template = data.result.template
        this.belonger = data.belonger
        this.payMethodArray = data.payMethod
        let array = data.result.edit.map((item) => {
          return this.formatPayment(item)
        })
        this.setEditPaymentData(array)
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .payment {
    .item {
      .edit {
        .hint {
          font-size: 14px;
          color: #F18148;
          .totalMoney {
            font-size: 12px;
          }
        }
      }
    }
  }
  .v-payment {
    position: relative;
    margin: 10px 0;
    .content {
      width: 100%;
      border: 2px dotted #DCE1E8;
    }
    .delete {
      position: absolute;
      top: 45%;
      right: -40px;
      .web-icon-close-tinny {
        font-size: 20px;
        color: #101010;
        cursor: pointer;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// index.vue?588bdb77